module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Desert King’s Pregnant Bride")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CHAPTER ONE")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("AGGIE")])])])]), _vm._v(" bowed her head against the sheets of icy rain as she plodded along the muddy road.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Slick fabric stuck to her where she’d forgotten to do up her raincoat. Water sluiced down her legs, into her wellington boots. Her hair, so carefully washed and dried, now hung in saturated rat-tails against her neck. Vaguely she was aware of the chill numbing her body. After running, stumbling, then trudging so far in the lashing darkness, her steps slowed, became unsteady.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If she’d been thinking clearly, she’d have taken her battered Jeep. That hadn’t occurred to her. One look between the carelessly drawn curtains of Marcus’s sitting room and coherent thought had fled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She’d stood, rooted to the spot, heedless of the drenching rain. When her brain had finally caught up with the message her eyes had conveyed, she’d simply run. She must have raced past her car into the welcoming blackness.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Pain tore at her throat as she sobbed in a deep racking breath. She had to get home, before the emotions churning inside overcame her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Yet she couldn’t escape the memory of what she’d seen: Marcus, naked in the arms of his lover.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('span', [_vm._v("Now she understood why he’d blown hot and cold, sometimes too busy to see her and at others attentive and loving. His ")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("affection had been a sham. He’d only wanted her to conceal his affair with the trophy wife of a jealous horse breeder.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("Maggie’s stomach churned. She’d been so gullible.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("She’d believed him when he’d spoken of respecting her, not rushing her after her recent loss. He’d said she needed to be sure before they took their relationship further.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("In her innocence Maggie "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("had")])]), _vm._v(" been sure. She’d decided to show him she was a desirable woman, mature and ready for a deeper relationship. She’d read every magazine she could lay her hands on, aiming to transform herself into the sort of woman she thought he wanted. She’d overcome her fears and thrust aside self-doubt. She’d even taken the long trip to town and bought herself a "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("dress")])]), _vm._v("!")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("Her bitter laughter was swallowed by the rushing wind.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("He’d never wanted her. She’d been too inexperienced and starved of affection to see he was using her. Nausea welled in her throat and she bent over to dry-retch again.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("Strangely, this time as she looked down she could see her boots and her legs, wet and muddy below the raincoat. She frowned muzzily, trying to focus on the present, not the scene of contorting naked bodies replaying in her head.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("Where was the light coming from?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("‘Do you need help?’ A deep voice curled out of the roaring darkness to reach her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("Blindly, she raised her head and found herself blinking in the headlights of a massive off-road vehicle. A man stood silhouetted before it. He was tall, lean and unfamiliar. Something about the set of his broad shoulders and his wide-planted feet intimated he was a man prepared for anything, a man able to deal with trouble of any kind.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("Maggie knew an instant’s insane craving to lean forward into his strong body, rest against those more-than-capable shoulders and slump into oblivion.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('span', [_vm._v("Then sense overcame instinct. She had no idea who he was. Besides, she’d just learned her judgement was fatally flawed. ")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("She’d believed Marcus to be everything she wanted in a man, a lover, a mate. She’d thought…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("The shadow moved closer, near enough to make her stunningly aware of his superior height and power.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘You’re not well. How can I assist?’ This time Maggie caught the faintest trace of an accent.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘Who are you?’ she said, barely recognising the reedy whisper as her own voice.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("Silence for a moment as the wind stirred the collar of her coat and drove the rain almost horizontal.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘I’m a guest at the Tallawanta Stud. Staying up at the homestead.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("Now she recognised the latest top-of-the-range vehicle. Only the best for those at the big house. And there was a special guest this week. The Sheikh of Shajehar, who owned the whole enormous horse stud, had sent an envoy on an inspection tour.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("That explained his accent. The precise, clipped English, as if he’d attended a top British public school. It was overlaid with a slight softening of consonants that hinted at something far more exotic.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘Or do you intend that we both stand out here till we’re saturated to the skin?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("There was no impatience in that voice, but nor was there any mistaking its steely undertone. Maggie jumped, reining in her wandering thoughts. What was wrong with her? She couldn’t seem to concentrate properly.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("Only now did she realise the stranger wore no overcoat. He must be even wetter than she.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘I’m sorry.’ She shook her head dazedly. ‘I’m not…’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘Have you been in an accident?’ Again that easy, calm voice with just a hint of iron in its depths.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('span', [_vm._v("‘No. No accident. I…Could you give me a lift, please?’ Maggie had no qualms now about cadging a ride from him. He was the visiting dignitary she’d heard about. They were ")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("on the estate’s private road and no one would be out in this weather unless they belonged here.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘Of course.’ He bowed his head, then preceded her to the four-wheel drive. His stride was long, purposeful and easy, as if pacing down a carpeted corridor instead of a muddy, uneven gravel road. Maggie stumbled after him as best she could, her limbs horribly uncoordinated.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("He opened the door and stood back for her to get in.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘Thank you,’ she murmured as a firm hand cupped her elbow and helped her into the high cabin. Without his support she wouldn’t have made it.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Maggie subsided onto the cushioned seat. Slowly she loosened her cramped fingers and let go of the straps of her high-heeled sandals from one hand, her frivolous new purse from the other. They tumbled to the floor. She’d barely been aware she still held them.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("The door closed and she sank back, stunned by the warm comfort of the cabin after the howling wind and teeming rain that had drummed incessantly in her ears.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("This was…luxury. Heaven.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Maggie shut her eyes, overcome by the quiet peace.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("‘Here,’ a deep voice filtered into her consciousness, ‘take this.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Slowly she turned towards the velvet-soft voice, fighting the intense dragging weariness that consumed her. She didn’t want to rouse herself, but he was insistent.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Reluctantly, she opened her eyes. He sat in the driver’s seat and she looked up into the blackest eyes she’d ever seen. Deep-set, hooded eyes that surveyed her closely, taking in every nuance of her appearance.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("Maggie’s eyes widened at the sight of her rescuer in the cabin’s pale overhead light.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('span', [_vm._v("His jet-black hair was slicked back from a face tanned almost to bronze. Her breath snagged at the strong, spare beauty of his features, each plane emphasised by the sheen of rain on bur")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("nished flesh. Lean cheeks with slanted cheekbones that mirrored the stark angle of his brows. A strong, aristocratic nose with just a hint of the aquiline. Narrow, well-shaped lips that she could imagine tipping into a smile or turning down in displeasure. A jaw that spoke of solid power and bone-deep assurance.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("The combination took her breath away. It was as if someone had opened a precious old book and conjured a warrior prince straight from the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Arabian Nights")])]), _vm._v(".")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("But nothing in her juvenile reading matched this man for pure magnetism. He looked exotic and masterful.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Maggie had never known any man could look so…")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("‘Here,’ he repeated, thrusting a soft woollen blanket into her hands. His brows angled down in a frown as he surveyed her. ‘Are you sure you’re not injured?’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("She nodded, then hid her face in the folds of wool, holding the blanket with hands that trembled. Embarrassment washed through her, whether because he’d caught her staring, or because of her strange wayward thoughts, she didn’t know.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("She must be in shock. That would explain her heedless flight and the muzzy feeling that everything was distant, unreal. Yes, that was it. Shock.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Any woman would be shocked to discover what she had tonight. And no doubt she looked a sight: workaday raingear over her beaded dress—")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("‘Stop it.’ A firm hand curved around her jaw and swung her face towards him. His fingers were hard and warm and comfortingly real against her numb flesh.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Maggie blinked, amazed to discover the water spiking her lashes wasn’t rain, but tears. They burned her eyes.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("‘Stop what?’ she whispered on a hiccough, staring into liquid dark eyes that held hers mesmerised.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', [_vm._v("Gradually her galloping heartbeat slowed. The breath shuddered out of her constricted lungs. She dragged in air, conscious of a tight ache around her chest.")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You were becoming hysterical.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("His clasp of her chin shifted, fingers splaying wide to tilt her head higher as if he needed to see her better in the dim light. The heat of his touch burned life back into her frozen skin and she was content to let him hold her so. She felt strangely lethargic.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘S-s-sorry.’ She frowned. She’d never stuttered in her life. And as for being hysterical…‘I’ve had a bit of a sh-shock.’ There, she finally got it out. She had trouble coordinating her lips and tongue. ‘I’ll be all r-right.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You’ve been out in this storm too long.’ He took the wool from her white-knuckled grasp and lifted the blanket around her shoulders, pulling the edges together. The enveloping comfort relaxed her into a boneless huddle and the movement drew him close. She caught his scent, faint yet intriguing. Heat and sandalwood, spice and damp male skin. Her nostrils flared as she slumped forward.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Large hands on her shoulders propped her away from him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Where did you come from? How long have you been out?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Maggie’s lips curved up in a dreamy smile as her eyelids drifted lower. She really did love that accent. The softening consonants and lilting rhythm almost hidden behind the crisp intonation sounded quite…seductive. She could imagine going to sleep to the sound of that voice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her eyes popped open as fingers curled hard into her shoulders.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Did someone hurt you?’ His voice sounded different. She shivered anew at the hint of anger in his tone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘No! No, I’m fine. Just…’ The words petered out and she blinked, confused. She really did feel odd. ‘I need to g-g-get back. Please.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Abruptly, he nodded, pushing her back into the moulded seat and reaching for her seat belt. The heat of his torso as he leant near was warmer by far than any blanket.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Where to?’")])])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He straightened and immediately the chill invaded her body again. When he switched on the ignition the cabin was plunged into darkness but for the light from the control panel. Her gaze strayed to his shadowy profile: powerful yet elegant in a toughly masculine way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Instinct told her she could trust him absolutely.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Another s-s-six k-kilometres. Then r-right. I’ll direct you f-from there.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He eased the vehicle forward. Rain pounded on the roof and the four-wheel drive slid in the thick mud.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mud. Her boots. Her gaze spanned the interior of the luxury vehicle.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I’m sorry,’ she whispered. ‘My b-boots are f-filthy.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘This is a farm vehicle,’ he responded. ‘I’m sure it collects its fair share of mud.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Spoken like a man who never had to clean said vehicle, Maggie realised. This was no work vehicle. It was reserved for important guests, used when only the best would do.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Who are you?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For a moment she thought he hadn’t heard her question over the sound of the rain.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘My name is Khalid. And yours?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Maggie.’ She hugged the blanket closer, ‘Maggie Lewis.’ Thank goodness her teeth had stopped chattering.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I’m pleased to meet you, Maggie.’ His voice was grave, almost formal. Suddenly she wondered how this man spent his time when he wasn’t visiting Australian horse studs or rescuing stranded women from deserted roads.")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', [_vm._v("Khalid concentrated on the road as driving conditions deteriorated. He had to get her warm and dry quickly. She was in shock and might be on the verge of hypothermia.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Six kilometres and then how far to reach her destination? He couldn’t take that risk. Instead he’d drive her to Tallawanta till she recovered.")])])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was an enigma. There was no abandoned car and those weren’t work clothes beneath her oilskin. The glimpse of long slender legs below her coat had instantly caught his interest. And the high heels she’d dangled from her hand were for dancing the night away or seducing a man.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Was that what had happened? Had some man hurt her?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Despite her height, tall enough to top his shoulder, there was a fragile air about this woman. Her shadowed eyes were huge in that milky pale face. Her bowed neck as she’d hunched over in the road was long and slender and delicate.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She hadn’t been at tonight’s dinner of luminaries who’d turned out to meet the heir to the throne of Shajehar. Khalid would have noticed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He flicked a glance at her, huddled beneath the tartan rug, her eyes closed and her head lolling against the seat. She looked weak and defenceless, but she must have a core of gritty strength to head out in this weather on foot. The woman was an intriguing mix that triggered his curiosity. That hadn’t happened in a long time.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He felt a spurt of satisfaction that tonight, for once, he was without his entourage of security aides and obsequious hosts. He could indulge his curiosity, follow his instincts. Given the tight perimeter security on the vast estate, he’d won the argument that he was safe alone within its boundaries. Perhaps his security chief had realised too that it would be wise to give him space.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For six weeks Khalid had dutifully toured his half-brother’s royal holdings in Europe, the Americas and Australia. But he didn’t share Faruq’s enjoyment of pomp and luxury. As heir to his terminally ill half-brother, Khalid had recently acquired a huge security retinue. Its size was due to Faruq’s love of ostentation rather than any threat. Plus he had a schedule full of social engagements.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("Social engagements! His time would be better spent super")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("vising his latest project, a fresh water pipeline from the mountains in remote Shajehar. At least that would bring tangible benefits to his people.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("Lights shone ahead in the streaming darkness and the tension eased across his shoulders and arms. Once he got her inside, in the light and warmth, he could assess her injuries, call a doctor if need be.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("He bypassed the garages and drove round to the private owner’s wing of the sprawling homestead.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("‘Here we are.’ He leaned across to shake her awake. She was limp beneath his hand. Frowning, he paused only a moment before touching her pale cheek. It was icy.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("‘Maggie! Wake up.’")])])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("That voice again. The crisp warm voice with its tantalising hint of a lilt. She smiled to herself as she pictured an exotic prince in flowing robes, a gleaming scimitar in his hand.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("‘Maggie!’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("She shrugged off a hand that threatened to interrupt her lovely dream. In her mind her prince smiled and tugged her to him. Eyes brighter than gems gleamed down at her and her breath caught. He slipped his hand beneath her legs and lifted her in his embrace, his arms like cushioned steel.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("She’d never felt so safe, so secure, so full of anticipation. Those black eyes were shadowed with the promise of unknown delight, his narrow lips curving in a knowing, sensuous smile that made her long for his kiss.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("The steady drum of his heartbeat pulsed against her and his arms rocked her close as he strode over the warm sand. Soon now they’d—")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("Maggie’s brows pleated as hard drops of water beat against her face. Did it rain in the desert?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', [_vm._v("Instinctively, she turned her head, snuggling closer to his warm, solid body, filling her nostrils with the evocative scent ")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("of man. But her frown grew as she discovered he was wet, his clothes sodden.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("She opened her eyes and found herself in a man’s arms as he strode through a howling rainstorm. Her startled gasp was torn away by the wind.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Carriage lights shone along the veranda of a classic-style colonial homestead. Warm light gleamed through a massive fanlight window above the door. Suddenly everything clicked into place. Marcus, the long walk home, the exotic stranger. They were at Tallawanta House.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("‘You can put me down.’ Maggie tried to lever herself up and out of his hold but she could get no purchase.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("‘We’re almost there.’ He stepped under cover and the needling rain on her skin ceased abruptly.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Wordlessly he pushed open the front door, pulling her closer. Muffled against his chest, she was assailed again by that yearning. To stay here against him, his body warming hers. To discover more about the inexplicable excitement that shivered through her blood when he held her like this.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("She squeezed her eyes shut. This was no fantasy. This was real. Yet she felt oddly relaxed, almost floating. A yawn seized her and her head lolled against his shoulder.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Khalid.")])]), _vm._v(" That was his name. She loved the sound of it. Her lips moved as she traced its syllables.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("A moment later his grip changed, strong arms holding her flush against him as he lowered her legs. She slid down a hard torso till her feet reached the floor. Yet it was his unyielding embrace that kept her upright.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("‘Now,’ murmured that seductively low voice, ‘it’s time to get your clothes off.’")])])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("‘What?’ Her eyes snapped open, instantly arresting him. In the bright light he found they were the colour of rich honey sprinkled with green fire. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Mesmerising.")])])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_vm._v("Unsteady hands shoved at his chest, fending him off.")])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Khalid’s lips firmed as he watched her battle to remain upright. Had someone taken advantage of her tonight? The idea sent heat roaring through his blood.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘You need to get your wet clothes off.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘Not with you watching!’ Pink tinted her cheeks, fascinating him, highlighting a spattering of light freckles. A woman who still knew how to blush. When was the last time he’d come across one of that rare breed?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I simply want to make sure you don’t get hypothermia. I’m not interested in your body.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The blush intensified to a deep rose hue and her gaze slanted swiftly away from his. Her teeth sank into her pale bottom lip. She was embarrassed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I can look after myself. I don’t need your help,’ she mumbled.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Didn’t she? His curiosity was roused, and his concern. And, damn it, his time was his own, for tonight at least.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Khalid had always believed in two things. Following his instinct and his duty. Years ago, in the darkest days of grief after Shahina’s death, only duty had kept him going. Embracing his responsibility to his people had given him purpose and strength when he’d wanted to shun the world and mourn his wife, the only woman he’d ever love.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Now both instinct and duty dictated he remain.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And something else. Something about Maggie Lewis that reached out to him in a way he hadn’t experienced in a long time. The realisation fascinated and appalled him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘So I should have left you out in the storm?’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("‘I didn’t mean that. I appreciate the lift.’ Her widening gaze roved the massive bathroom as if she’d never seen marble tiles before. ‘It would have been easier to take me home.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Her words were still slurred. But her eyes were clear and bright, the pupils normal. He guessed it was hypothermia, not drugs or drink, affecting her speech.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("He released his hold slowly, looking to ensure she could ")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("stand alone. Then he shrugged out of his dinner jacket and draped it over the edge of the spa bath.")])]), _c('p', {
    staticClass: "spaceBreak"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Maggie watched his swift, economical movements as he turned and took off his jacket. The frame of his spectacular shoulders, the impressive V of his torso, the classic male form of powerful chest and narrow waist. The wet shirt clung lovingly to every inch of his skin, and her mouth dried, absorbing all that physical perfection.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Fiery heat burned her face as embarrassment sizzled under her skin. Of course he wasn’t interested in seeing her naked! She’d always been gawky and unattractive. A wave of anger and humiliation broke over her, threatening to tug her down into a tide of self-pity.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Rapidly she blinked. She’d known for years she wasn’t the sort of girl men desired. Tonight had only just confirmed…no, she refused to go there. The memory was too raw, too mortifying.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("There was a whoosh of water and she dragged her focus back to the present. He’d leaned in to turn on the shower. His black trousers were sodden, shaping long, powerful legs and a tightly curved backside.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Maggie’s eyes widened. Even Marcus, with his laughing blue eyes and his tall chunky build, couldn’t hold a candle to this man for sheer physical perfection.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("‘Let me help you with your coat.’ He didn’t wait for an answer. Clearly he was used to being obeyed.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Wordlessly she stood while he deftly slipped it from her shoulders. It dropped in a puddle at her feet.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Maggie fixed her gaze on his black silk bow tie rather than on that vast expanse of wet male torso. But, perversely, the longer she stared, the greater her desire to reach out and tug the tie undone, to part the collar and see whether the flesh over his collarbone was the same burnished gold as his face.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Horrified at the wayward thought, she shut her eyes against ")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("temptation. She’d never felt quite so…abandoned. Had tonight short-circuited something in her brain?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("She was shocked to realise she hadn’t felt anything like this for Marcus. She’d cared for him, respected him and believed intimacy was the next logical step in their relationship. But she’d never felt this charged awareness of him as a man.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Now she felt edgy, as if her skin had grown too tight.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Was this desire?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Her experience was so limited. She’d spent her life on the farm, isolated by her domineering father and long work hours. That was why her fledgling relationship with Marcus had seemed so precious.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘Next your dress, then we’ll see if you can manage alone.’ Khalid’s voice was matter-of-fact. Yet he could have been reciting entries in the telephone directory and she’d have listened, enthralled, to his sexy smooth voice.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("No! This had to stop. The sooner he left, the better. Then she’d become herself again: ordinary, pragmatic Maggie Lewis. No more flights of fantasy, no more…melting at the mere sound of a voice. This responsiveness to a complete stranger was due to shock and tiredness.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Maggie bit her lip on an instinctive protest as he reached round to the back of her dress. Her hands were so unsteady she knew she’d never manage the zip herself. So she complied, holding herself still as he tugged the zip.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Its downward slide took for ever. Blood pounded in her ears, blocking the sound of the shower. The sensation of the fastening lowering, centimetre by slow centimetre, drew her skin tight in goose flesh. He didn’t touch her but he stood close, arms encircling her, his heat enfolding her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("She swayed then, horrified, caught herself and stood straighter, her spine ramrod stiff.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("‘There. Almost done.’ His voice was expressionless, his eyes on the dress as he peeled it gently down.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("He might have been undressing a store dummy for all the ")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("interest he showed. And that, for some reason, was worse than anything that had gone before.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("A shimmer of furious tears blurred Maggie’s vision.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Here she stood, naked but for her brand-new ultra-feminine underwear, and he didn’t even spare her a glance. It was as if she weren’t a flesh-and-blood woman. Not a real one, capable of snaring a man’s interest.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Who did she think she was kidding with her new clothes? Her body was too long, with too few curves. She had none of the sensuality other women took for granted.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("The only time men noticed her was at work, for she was good at her job. In the stables she was one of the guys. Didn’t that say it all? Something deep inside shrivelled up. An ache cramped her belly and she hunched over.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("‘Maggie? Are you in pain?’ Eyes of fathomless black met hers. His hard, callused hands bit into her shoulders.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("‘No.’ It emerged as a desperate gasp. ‘But I need to be alone. Go. Please.’")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("His gaze raked hers. His mouth firmed into a grim line. Then slowly his fingers loosed their grip and his arms swung to his sides.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("‘As you wish.’ Abruptly he was gone, leaving her in solitary possession of the magnificent bathroom.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("For a bereft moment she wanted to call him back, ask him to hold her, to protect her from the hurt that welled up inside and the marrow-deep cold that gripped her body.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Then pride reasserted itself. He’d been only too thankful to escape. Besides, she was used to managing alone. That was the way it had always been.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("She turned towards the shower, her steps as slow as an old woman’s. She didn’t bother to lock the door to ensure her privacy. There was no need.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Why did the knowledge hurt so much?")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e078180","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/desertkingspregnantbridethe_ch01.vue
// module id = 75
// module chunks = 0